<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <validation-observer ref="taxesDetailForm">
        <b-form ref="taxesDetailFormElement" class="" @submit.prevent="submit">
          <b-row>
            <b-col lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="description">{{ t('Tax Name') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Tax Name')" rules="required">
                  <b-form-input
                    id="name"
                    v-model="values.description"
                    name="description"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Tax Name')"
                    tabindex="1"
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="rate">{{ t('Rate') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Rate')" rules="required">
                  <b-form-input
                    id="rate"
                    v-model="values.rate"
                    name="rate"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Rate')"
                    tabindex="2"
                    step="0.01"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="applicationScope">{{ t('Scope') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Scope')" rules="required">
                  <v-select
                    id="applicationScope"
                    v-model="values.applicationScope"
                    :options="taxApplicationScopes"
                    :reduce="item => item.value"
                    :placeholder="t('Make a Choice')"
                    label="text"
                    :tabindex="3"
                  >
                    <span slot="no-options">{{ t('No records found') }}</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-checkbox v-model="values.status" name="check-button" switch>
                {{ values.status ? t('Active') : t('Passive') }}
              </b-form-checkbox>

              <b-button
                variant="primary"
                class="mt-1 d-flex align-items-center"
                type="submit"
                tabindex="4"
              >
                {{
                  submitting
                    ? t('Please Wait')
                    : type === 'new'
                    ? t('Create Taxes')
                    : t('Edit Taxes')
                }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-overlay>
  </div>
</template>
<script>
import {
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BFormCheckbox,
  BButton,
  BOverlay
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';

export default {
  components: {
    BOverlay,
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    vSelect,

    ValidationObserver,
    ValidationProvider
  },
  mixins: [helper],
  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          description: '',
          rate: '',
          applicationScope: '',
          status: true
        };
      }
    }
  },
  data() {
    return {
      taxStatus: [],
      taxApplicationScopes: []
    };
  },
  async created() {
    try {
      const response = await this.getTaxApplicationScope();
      this.taxApplicationScopes = (response || []).map(item => ({
        text: item.info,
        value: item.value
      }));
    } catch (e) {
      this.showErrorMessage(this.$t('Failed to load data'));
    }
  },
  methods: {
    submit() {
      this.$refs.taxesDetailForm.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            ...this.values,
            status: this.values.status ? 1 : 0
          });
        }
      });
    },
    resetForm() {
      this.$refs.taxesDetailFormElement.reset();
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
